import imgBckgrd from '../../images/ocean-waves-1.jpg';

function Background({ ind }) {
    return (
        <div className="full-size-container">
            <img id="full-size-img" className="full-size-img" src={require(`../../images/ocean-waves-${ind}.jpg`)}
                alt="ocean waves" />
        </div>
    );
}

export default Background;